import React from 'react';
import { CollapseBlock } from '../../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';
import FormTextField from '../../../../../antd/form/FormTextField/FormTextField.jsx';
import FormTextEditor from '../../../../../antd/form/FormTextEditor/FormTextEditor.jsx';
import FormButton from '../../../../../antd/form/FormButton/FormButton.jsx';
import FormButtonsContainer from '../../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormSelect from '../../../../../antd/form/FormSelect/FormSelect.jsx';
import { required } from '../../../../../antd/form/FormValidation.js';
import { documentTypes } from '../../../../../../hooks/useFileDraggerFileValidation.jsx';

const PageForm = ({ wikiCategories }) => {
  const { t } = useTranslation();

  return (
    <>
      <CollapseBlock>
        <FormTextField
          label={t('Názov')}
          name={'title'}
          rules={[required(t)]}
        />

        <FormSelect
          label={t('Kategória')}
          name={'wiki_category_id'}
          rules={[required(t)]}
          options={(wikiCategories || []).map((category) => ({
            label: category.name,
            value: category.id,
          }))}
        />

        <FormTextEditor
          label={t('Obsah')}
          name={'content'}
          rules={[required(t)]}
          imgUploadDirectory={'wiki_pages'}
          fileUploadDirectory={'wiki_pages'}
          allowedTypes={documentTypes}
          contentClassName={'rich-content rich-content--steps'}
        />

        <FormButtonsContainer>
          <FormButton submitOnClick={true} submitKey={'wiki-pages'}>
            {t('Uložiť')}
          </FormButton>
        </FormButtonsContainer>
      </CollapseBlock>
    </>
  );
};

export default PageForm;
